module.exports = __webpack_public_path__ + "img/Screenshot_2026-10-20-00-32-02-398_com.xingin.xhs.cda645c3.jpg";